import Axios from 'axios'

export interface BlogCategory {
  name: string
  slug: string
  color: string
}

export interface BlogTag {
  name: string
  slug: string
}

export interface BlogPost {
  id: number
  title: string
  slug: string
  excerpt: string | null
  featured_image: string | null
  published_at: string | null
  reading_time: number
  views: number
  author: {name: string} | null
  category: BlogCategory | null
  tags: BlogTag[]
  meta_title: string | null
  meta_description: string | null
  content?: string
  related?: BlogPost[]
}

export interface BlogPostsResponse {
  posts: {
    data: BlogPost[]
    current_page: number
    last_page: number
    per_page: number
    total: number
    links: {url: string | null; label: string; active: boolean}[]
  }
  categories: (BlogCategory & {posts_count: number})[]
  tags: (BlogTag & {posts_count: number})[]
}

const client = Axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: {Accept: 'application/json'},
})

export const blogApiClient = {
  getPosts: async (params?: {
    search?: string
    category?: string
    tag?: string
    page?: number
  }): Promise<BlogPostsResponse> => {
    const res = await client.get('/api/blog/posts', {params})
    return res.data
  },

  getPost: async (slug: string): Promise<BlogPost> => {
    const res = await client.get(`/api/blog/posts/${slug}`)
    return res.data
  },
}
